import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { GameShowDataService } from 'app/teacher/game-show/services/game-show-data.service';

export const validateGameshowExists: CanActivateFn = (route) => {
  const gameShowDataService = inject(GameShowDataService);
  const router = inject(Router);
  const activityId = route.paramMap.get('activityId');

  if (!activityId) {
    return router.createUrlTree(['/not-found']);
  }

  return gameShowDataService.getGameShow(activityId)
    .pipe(
      map((result) => (result ? true : router.createUrlTree(['/not-found']))),
      catchError(() => of(router.createUrlTree(['/error'])))
    );
};
